import {
    PACKET_STATUS_REQUEST,
    PACKET_STATUS_SUCCESS,
    PACKET_STATUS_FAILURE,
  } from "../actions/actionTypes";
import apiClient from "../../utils/apiClient";
  
  export const packetStatusThunk = (regId) => {
    return async (dispatch) => {
      dispatch({ type: PACKET_STATUS_REQUEST });
      let errorData = "";

      try {
        const response = await apiClient.post("/checkPacketStatus", { regId });
        const data = response.data;
         
      
  
        dispatch({ type: PACKET_STATUS_SUCCESS, payload: data });
  
      } catch (error) {
        errorData = error.response?.data || errorData;
        dispatch({
          type: PACKET_STATUS_FAILURE,
          payload:
            errorData || "Verification failed. Please try again later.",     
        });
  
      }
    };
  };
  